import { useTranslation } from 'providers/GILT.provider';

import { TooltipMetricTexts } from './TooltipMetricTexts.component';

import CN from './TooltipMetricTextForecast.module.scss';

const ClientsBoughtRetailPct = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.clientsBoughtRetailPct.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.clientsBoughtRetailPct.rule1')}</div>
  </div>
);

const RebookingRatePct = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.rebookingRatePct.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.rebookingRatePct.rule1')}</div>
  </div>
);

const RebookingRateNewClientsPct = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.rebookingRateNewClientsPct.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.rebookingRateNewClientsPct.rule1')}</div>
  </div>
);

const RebookingRateExistingClientsPct = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.rebookingRateExistingClientsPct.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.rebookingRateExistingClientsPct.rule1')}</div>
  </div>
);

const TotalRevenue = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.totalRevenue.description')}
    <span></span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.totalRevenue.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.totalRevenue.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.totalRevenue.rule3')}</span>
    {t('composite.tooltipKpisMetricsForecast.totalRevenue.description2')}
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.totalRevenue.rule4')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.totalRevenue.rule5')}</span>
  </div>
);

const RevenueExclRetail = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.revenueExclRetail.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.revenueExclRetail.description2')}</div>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.revenueExclRetail.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.revenueExclRetail.rule2')}</span>
  </div>
);

const RetailRevenue = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.retailRevenue.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.retailRevenue.rule1')}</div>
  </div>
);

const AvgBillValue = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.avgBillValue.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.avgBillValue.rule1')}</div>
  </div>
);

const RevenuePerCategory = ({ t }) => (
  <div className={CN.component}>
    {t('composite.tooltipKpisMetricsForecast.revenuePerCategory.description')}
    <span></span>
    <div>{t('composite.tooltipKpisMetricsForecast.revenuePerCategory.description2')}</div>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.revenuePerCategory.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.revenuePerCategory.rule2')}</span>
  </div>
);

const ClientsRebookedCount = ({ t }) => (
  <div className={CN.component}>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.clientsRebookedCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.clientsRebookedCount.rule2')}</span>
  </div>
);

const NewClientsRebookedCount = ({ t }) => (
  <div className={CN.component}>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.newClientsRebookedCount.rule1')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.newClientsRebookedCount.rule2')}</span>
    <span className={CN.dot}>{t('composite.tooltipKpisMetricsForecast.newClientsRebookedCount.rule3')}</span>
  </div>
);

// Main component
const TooltipMetricTextForecast = ({ metric }) => {
  const { t } = useTranslation();

  switch (metric) {
    case 'clients_bought_retail_pct':
      return <ClientsBoughtRetailPct t={t} />;
    case 'rebooking_rate_pct':
      return <RebookingRatePct t={t} />;
    case 'rebooking_rate_new_clients_pct':
      return <RebookingRateNewClientsPct t={t} />;
    case 'rebooking_rate_existing_clients_pct':
      return <RebookingRateExistingClientsPct t={t} />;
    case 'total_revenue':
      return <TotalRevenue t={t} />;
    case 'revenue_excl_retail':
      return <RevenueExclRetail t={t} />;
    case 'retail_revenue':
      return <RetailRevenue t={t} />;
    case 'avg_bill_value':
      return <AvgBillValue t={t} />;
    case 'revenue_per_category':
      return <RevenuePerCategory t={t} />;
    case 'clients_rebooked_count':
      return <ClientsRebookedCount t={t} />;
    case 'new_clients_rebooked_count':
      return <NewClientsRebookedCount t={t} />;
    default:
      return <TooltipMetricTexts metric={metric} />;
  }
};

export default TooltipMetricTextForecast;
